import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import BaseComponent from 'utils/BaseComponent'
import request from 'utils/request'

import RetractablePanel from 'components/RetractablePanel'
import Input from 'components/Input'
import Button from 'components/Button'
import ConfirmationModal from 'components/ConfirmationModal'
import PocModal from './PocModal'

import { statusChanged } from 'components/RequestStatus/actions'
import { claimChanged } from 'scenes/VehicleDetail/actions'

import { CLAIM_UPDATE } from 'constants'
import { CLAIM_POCS } from 'constants'
import { POCS } from 'constants'

import './styles.scss'

export class SMSSetup extends BaseComponent {


  constructor(props) {
    super(props)
    this.state = {
      editting: false,
      name: '',
      phone: '',
      pocs: [],
      errors: {
        name: [],
        phone: []
      }
    }

    this._bind( 
                '_onEdit', '_handleSubmit', '_handleChange', 
                '_renderSMSEnabled', '_renderSMSDisabled',
                '_showConfirmationModal', '_enableSMS', '_disableSMS',
                '_showDisableModal', '_renderNoPocs', '_renderPocs',
                '_pocCreated', '_getPocs',
                '_onCancelEdit', '_renderContactForm', '_renderContactData',
                '_upadteContact')
  }

  componentDidMount() {
    this._getPocs()
  }

  _onEdit(e) {
    e.preventDefault()
    this.panel.open()
    this.setState({ editting: true })
  }

  _onCancelEdit(e) {
    e.preventDefault()
    this.panel.open()
    this.setState({ editting: false })
  }

  _renderHeaderActions() {
    if (!this.state.editting && this.props.claim.sms_enabled && this.state.pocs.length > 0){
      return (
        <div>
          <button onClick={this._onEdit}>
            <i className="material-icons">edit</i>
          </button>
        </div>
      )
    } else if( this.state.editting ){
      return (
        <div>
          <button onClick={this._onCancelEdit}>
            <i className="material-icons">close</i>
          </button>
        </div>
      )
    }
    return null
  }

  _renderButton() {
    const isActive = this.state.isActive
    const isClosed = this.state.isClosed
    if(isActive && isClosed === false) {
      return (
        <button type="button" className="btn btn-outline-danger" onClick={this._claimStatus} name="is_closed">Terminar seguimiento</button>
      )
    } else {
      return (
        <button type="button" className="btn btn-outline-success" onClick={this._claimStatus} name="is_active">Iniciar seguimiento</button>
      )
    }
  }

  _handleSubmit(e) {
    e.preventDefault()
    var errors = {
      name: [],
      phone: []
    }
    var form_ok = true
    e.preventDefault()
    if (this.state.name === '') {
      errors['name'] = ['El nombre es requerido']
      form_ok = false
    }
    if (this.state.phone === "") {
      errors['phone'] = ['El celular es requerido']
      form_ok = false
    }
    if (this.state.phone.length !== 10 || isNaN(this.state.phone)) {
      errors['phone'] = ['Se requieren 10 digitos']
      form_ok = false
    }
    this.setState({ "errors": errors })

    if (form_ok){
      this._upadteContact()
    }
  }

  _upadteContact() {
    const formData = new FormData()
    
    formData.append('name', this.state.name)
    formData.append('phone', this.state.phone) 

    var pocs = this.state.pocs
    var poc_id = ''
    if (pocs.length > 0){
      poc_id = pocs[0].id
    }else{
      this.props.updateRequestStatus('error', 'No pudimos modificar los datos')
      return
    }

    this.props.updateRequestStatus('progress', 'Modificando datos de contacto...')
    request(POCS(poc_id), {
      method: 'PUT',
      isUpload: true,
      body: formData
    }).then((res) => {
      this.props.updateRequestStatus('ok', 'Datos modificados')
      var name = res['name'] 
      var phone = res['phone'] 
      this.setState({
        pocs: [res],
        name: name,
        phone: phone
      })
    }).catch((err) => {
      this.props.updateRequestStatus('error', 'No pudimos modificar los datos')
    })

    this.setState({
      editting: false
    })
  }

  _handleChange(e) {
    this.setState({ [e.target.name]: e.target.value })      
  }

  _renderPocs(){
    var poc = this.state.pocs[0]
    return (
      <span>
      <p className="strongText">Punto de contacto</p>
      <div className="data-field">
        <label>Nombre:</label>
        <p><span>{poc['name']}</span></p>
      </div>
      <div className="data-field">
        <label>Teléfono:</label>
        <p><span>{poc['phone']}</span></p>
      </div>
      </span>
    )
  }

  _renderNoPocs(){
   return (
      <p>Debes registrar un punto de contacto</p>
    ) 
  }

  _renderSMSEnabled() {
    return (
      <span>
        { this.state.editting ? this._renderContactForm() : this._renderContactData() }
      </span>
    )
  }

  _renderContactForm(){    
    return (
      <div>
        <form onSubmit={this._handleSubmit} className="f-flex SMSData__form">
          <div className="form-field">
            <label>Nombre:</label>
            <Input  onChange={this._handleChange}
                    name="name"
                    value={this.state.name}
                    placeholder="Nombre del contacto"
                    errors={this.state.errors.name}/>
          </div>
          <div className="form-field">
            <label>Celular:</label>
            <Input  onChange={this._handleChange}
                    name="phone"
                    value={this.state.phone}
                    placeholder="Ej: +521 9212050938"
                    errors={this.state.errors.phone}/>
          </div>
          <div className="controls d-flex justify-content-end">
            <Button buttonType="primary"
                    size="small">Guardar contacto</Button>
          </div>
        </form>
      </div>
    )
  }

  _renderContactData(){
    return(
      <div className="SMSData__data">
        { (this.state.pocs.length === 0) ? this._renderNoPocs() : this._renderPocs() }
        <div className="controls d-flex justify-content-end">
          <Button type="button" 
                  className="btn btn-outline-danger"
                  onClick={this._showDisableModal}>
                  Desactivar SMS</Button>
        </div>
      </div>
    )
  }

  _showConfirmationModal(e){
    e.preventDefault()
    var title = "Confirmación de activación de SMS"
    var message = "Esto generará costos adicionales al cliente. ¿Estás seguro que quieres activarlo?. Puede ser desactivado en cualquier momento."
    var hideModal = !(this.state.pocs.length === 0)
    this.context.toggleModal(
      true,
      <ConfirmationModal 
                          _onAccept={this._enableSMS.bind(this)}
                          match={this.props.match} 
                          title={title}
                          acceptLabel="Activar"
                          message={message}
                          hideModal={hideModal}
      />
    )
  }


  _showDisableModal(e){
    e.preventDefault()
    var title = "Confirmación para desactivar SMS"
    var message = "Cuando deshabilitas esta funcionalidad el cliente ya no recibirá notificaciones vía SMS."
    this.context.toggleModal(
      true,
      <ConfirmationModal 
                          _onAccept={this._disableSMS.bind(this)}
                          match={this.props.match} 
                          title={title}
                          acceptLabel="Desactivar"
                          message={message}
      />
    )
  }

  _getPocs(){
    // this.props.updateRequestStatus('progress', 'Cambiando estado de siniestro...')
    request(CLAIM_POCS(this.props.claim.id), {
      method: 'GET'
    }).then((res) => {
      var name = ''
      var phone = ''
      if (res.length > 0){
        var poc = res[0]
        name = poc['name']
        phone = poc['phone']
      }
      this.setState({
        pocs: res,
        name: name,
        phone: phone
      })
      // this.props.updateRequestStatus('ok', 'Contactos descargados')
    }).catch((err) => {
      this.props.updateRequestStatus('error', 'No pudimos obtener los contactos')
    })
  }

  _pocCreated(){
    this._getPocs()
    this._enableSMS()
  }

  _showPocModal(){
    this.context.toggleModal(
      true,
      <PocModal claim={this.props.claim}
                _onSuccess={this._pocCreated.bind(this)}
      />
    )
  }

  _eSMS(){
      this.props.claimChanged({
        ...this.props.claim,
        sms_enabled: true
      })
  }

  _enableSMS(){
    if (this.state.pocs.length === 0){
      this._showPocModal()
    }else{
      const formData = new FormData()
      formData.append('sms_enabled', true)
  
      this.props.updateRequestStatus('progress', 'Modificando datos del siniestro...')
      request(CLAIM_UPDATE(this.props.claim.id), {
        method: 'PUT',
        isUpload: true,
        body: formData
      }).then((res) => {
        this.props.updateRequestStatus('ok', 'Datos modificados')
        this.props.claimChanged({
          ...this.props.claim,
          sms_enabled: true
        })
      }).catch((err) => {this.props.updateRequestStatus('error', 'No pudimos modificar los datos')})
  
      this.setState({
        editting: false
      })
    }
  }

  _disableSMS(){
    const formData = new FormData()
    formData.append('sms_enabled', false)

    this.props.updateRequestStatus('progress', 'Modificando datos del siniestro...')
    request(CLAIM_UPDATE(this.props.claim.id), {
      method: 'PUT',
      isUpload: true,
      body: formData
    }).then((res) => {
      this.props.updateRequestStatus('ok', 'Datos modificados')
      this.props.claimChanged({
        ...this.props.claim,
        sms_enabled: false
      })
    }).catch((err) => {this.props.updateRequestStatus('error', 'No pudimos modificar los datos')})

    this.setState({
      editting: false
    })
  }

  _renderSMSDisabled() {
    return(
      <div className="ActivateSMSSection">
        <label>Únicamente activarse si el clientes no va a utilizar la app, ni reportes por correo. Al activarse, cada que se envíe una notificación se solicitará redactar una versión SMS. Cada SMS generará un costo al cliente.</label>
        <center><button type="button" className="btn btn-outline-primary" onClick={this._showConfirmationModal} name="is_active">Activar SMS</button></center>
      </div>
    )
  }

  render() {
    return(
      <div id="SMSData" className="SMSData">
        <RetractablePanel
          ref={(panel) => this.panel = panel}
          name="Actualizaciones SMS - Punto de contacto"
          actionButtons={this._renderHeaderActions()}
          isToggle={true}
        >
          { this.props.claim.sms_enabled ? this._renderSMSEnabled() : this._renderSMSDisabled() }
        </RetractablePanel>
      </div>
    )
  }
}

SMSSetup.contextTypes = {
  toggleModal: PropTypes.func.isRequired
}


const mapStateToProps = (state) => {
  return {
    claim: state.vehicleDetail.get('claim')
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateRequestStatus: (status, message) => dispatch(statusChanged(status, message)),
    claimChanged: (vehicle) => dispatch(claimChanged(vehicle))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SMSSetup)



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/ClaimData/SMS/index.js